/*
// COPIED FROM GOOGLE
<!-- The core Firebase JS SDK is always required and must be listed first -->
<script src="https://www.gstatic.com/firebasejs/8.6.2/firebase-app.js"></script>

<!-- TODO: Add SDKs for Firebase products that you want to use
     https://firebase.google.com/docs/web/setup#available-libraries -->

<script>
  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyBwdvO3mQlzYmIDXJfiXQwLyJNzgxg6xy0",
    authDomain: "saviour-of-savour.firebaseapp.com",
    projectId: "saviour-of-savour",
    storageBucket: "saviour-of-savour.appspot.com",
    messagingSenderId: "229005702892",
    appId: "1:229005702892:web:8a37c48b109032fbf997c9"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
</script>
 */

import firebase from "firebase/app";
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyBwdvO3mQlzYmIDXJfiXQwLyJNzgxg6xy0",
  authDomain: "saviour-of-savour.firebaseapp.com",
  projectId: "saviour-of-savour",
  storageBucket: "saviour-of-savour.appspot.com",
  messagingSenderId: "229005702892",
  appId: "1:229005702892:web:8a37c48b109032fbf997c9",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

// getDataByName(name) {
//   return firebase.firestore().collection(name).
//   then((querysnapshot) => {
//     querysnapshot.forEach((doc) => {
//       /* just to make sure data is fetched correctly*/
//       // console.log(doc.id, "=>", doc.data());
//       this.state.orders.push({ orderId: doc.id, ...doc.data() });
//     });
//   }
// },



export { timestamp };
export default firebaseApp.firestore();
